<template>
  <div
    v-if="date !== undefined"
    class="flex items-center"
  >
    <div class="text-4xl leading-none font-semibold">
      {{ date.getDate() }}
    </div>
    <div class="ml-1">
      <div class="leading-none">
        {{ date | moment("MMM") }}
      </div>
      <div class="leading-none">
        {{ date | moment("YYYY") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {

  components: {
  },

  props: {
    date: {
      type: Date,
      default: undefined,
    },
  },

  data() {
    return {

    };
  },

};
</script>
